<template lang="pug">
section.features(:id='getId()')
    .top
    .content.d-column.align-items-sm-center
        .row
            .col-1
            .col-10.my-5.text-center.text-uppercase(:class='inverted ? "text-sm-right" : "text-sm-left"')
                h4.title {{ title }}
            .col-1
            .col-1
            .col-2.sub-menu.d-none.d-sm-block(:class='inverted ? "order-sm-6" : ""')
                .nav.flex-column(:id='getId("-tab")' role='tablist', aria-orientation='vertical')
                    a.nav-link(v-for='t in tabs' :id='t.attr.navLinkId' :class='t.attr.navLinkClass', data-toggle='pill', :href='getRef(t.attr.tabPaneId)', role='tab', :aria-controls='t.attr.tabPaneId', :aria-selected='t.active') {{ t.label }}
            .col-10.col-sm-8.tab-content(:id='getId("-tabContent")' :class='inverted ? "order-sm-5" : ""')
                .tab-pane.fade(v-for='t in tabs' :id='t.attr.tabPaneId' :class='t.attr.tabPaneClass' role='tabpanel', :aria-labelledby='t.attr.navLinkId')

                    .row(v-if='t.content.type === SECTION.DEFINITION')
                        .col-12.col-sm-4.image-container.d-flex.align-items-center.justify-content-center(:class='t.inverted ? "order-sm-2" : ""')
                            img.img-fluid.image(:src='t.content.img')
                            oc-play-button(:videoUrl='t.content.pUrl')
                        .col-12.col-sm-8.my-4.my-sm-0.d-flex.align-items-center(:class='t.inverted ? "order-sm-1" : "pl-sm-4"')
                            p.text-justify(v-html='t.content.html')
                        .col-12.py-3.pt-sm-0.text-center(:class='t.inverted ? "order-sm-3 text-sm-left" : "text-sm-right"')
                            a.btn.btn-primary.btn-lg.mt-1(href="#eventos", role='button') Ver Calendario de Cursos 

                    .row(v-else-if='t.content.type === SECTION.BOOK')
                        .col-12.col-sm-4.pl-sm-4.image-container.d-flex.align-items-center.justify-content-center.order-sm-2
                            img.img-fluid.image.p-5.p-sm-0(:src='t.content.img')
                        .col-12.col-sm-8.order-sm-1.d-column.align-items-center
                            p.text-justify.d-block(v-html='t.content.html ')
                            .text-center.text-sm-right.d-block
                                oc-paypal-button(:value='t.content.payPalValue')
                        .col-12.col-sm-8.order-sm-3.pt-3.pt-sm-0.text-center.text-sm-center

                    .row(v-else-if='t.content.type === SECTION.TEXT')
                        .col-12.col-sm-12
                            p.text-justify.d-block(v-html='t.content.html ')

                    .carousel.py-5.pt-sm-0.d-flex.align-items-center.slide(v-else-if='t.content.type === SECTION.POTHOS' :id='t.attr.carouselId' data-ride='carousel', :data-interval='t.content.timeInterval')
                        ol.carousel-indicators
                            li(v-for='(s,i) in t.content.slides' :data-target='getRef(t.attr.carouselId)', :data-slide-to='i')
                        .carousel-inner.d-flex.align-items-center
                           .carousel-item.text-center(v-for='(s,i) in t.content.slides' :class='i===0 ? "active" : ""')
                               img.img-fluid.img-thumbnail(:src='s')
                        a.carousel-control-prev(:href='getRef(t.attr.carouselId)', role='button', data-slide='prev')
                            span.carousel-control-prev-icon(aria-hidden='true')
                            span.sr-only Previous
                        a.carousel-control-next(:href='getRef(t.attr.carouselId)', role='button', data-slide='next')
                            span.carousel-control-next-icon(aria-hidden='true')
                            span.sr-only Next
                    .col-1
        oc-arrow(:urlRef='nextRef')
</template>

<script>
import OcPlayButton from '@/components/shared/PlayButton.vue'
import OcPaypalButton from '@/components/shared/PaypalButton.vue'
import OcArrow from '@/components/shared/Arrow.vue'

import SECTION from  '@/constants/section-types'

export default {
    components: {OcPlayButton, OcPaypalButton, OcArrow},
    props: {
        sectionId: { type:String, required: true },
        title: { type:String, required: true },
        tabsContent: { type:Array, required: true},
        nextRef: { type:String, required: true },
        inverted: {type:Boolean, required: false}
    },
    data () {
        return {
            SECTION: SECTION,
            tabs: []
        }
    },
    methods: {
        getId (pos = '') { return `${this.sectionId}${pos}` },
        getRef (id) { return `#${id}` }
    },
    beforeMount () {        
        this.tabs = this.tabsContent.map( tab => {
            return Object.assign({}, tab, { 
                attr: {
                    navLinkId: `${this.sectionId}-${tab.id}-tab`,
                    navLinkClass: `${this.inverted ? 'inverted' : ''} ${ tab.active ? 'active' : '' }`,
                    tabPaneId: `${this.sectionId}-${tab.id}`,
                    tabPaneClass: tab.active ? 'show active' : '',
                    carouselId: `carousel${this.sectionId}Indicators`                
                }
            })
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Section.vue